/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_Area_MaxInputs */

const cs_public_site_demand_area_max = /** @type {(inputs: Public_Site_Demand_Area_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plocha do (m²)`)
};

const en_public_site_demand_area_max = /** @type {(inputs: Public_Site_Demand_Area_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area to (m²)`)
};

/**
* | output |
* | --- |
* | "Area to (m²)" |
*
* @param {Public_Site_Demand_Area_MaxInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_area_max = /** @type {((inputs?: Public_Site_Demand_Area_MaxInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_Area_MaxInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_area_max(inputs)
	return cs_public_site_demand_area_max(inputs)
});